/* eslint-disable max-len */
import { FC } from 'react';

import { GenericIconProps } from '../Icon';

const GoogleMeetIcon: FC<GenericIconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2095_34534)">
        <path
          d="M5 1.75L0 6.75L2.5 8.29754L5 6.75L6.41176 4.25L5 1.75Z"
          fill="#FF2820"
        />
        <path d="M5 6.75H0V13.25L2.5 14.6229L5 13.25V6.75Z" fill="#0084FF" />
        <path
          d="M0 13.25V16.5833C0 17.5 0.75 18.25 1.66668 18.25H5L6.41176 15.596L5 13.25H0Z"
          fill="#0066DD"
        />
        <path
          d="M18.9681 3.52524L15.8757 5.97488V6L14.8672 9.85039L15.8757 13.747L18.9544 16.2248C19.3674 16.5714 20.0007 16.2802 20.0007 15.7395V4.01047C20.0007 3.46977 19.3812 3.17863 18.9681 3.52524Z"
          fill="#00AD3C"
        />
        <path
          d="M15.875 5.97488V3.39754C15.875 2.49141 15.1409 1.75 14.2438 1.75H10.9812H5V6.75H11.125V10L14.4158 9.6334L15.875 5.97488Z"
          fill="#FFBA00"
        />
        <path
          d="M11.125 13.25H5V18.25H10.9812H14.2438C15.1409 18.25 15.875 17.5097 15.875 16.6048V13.75L14.2425 10.3961L11.125 10V13.25Z"
          fill="#00AD3C"
        />
        <path
          d="M11.125 9.99973L15.875 13.7497V5.97461L11.125 9.99973Z"
          fill="#00831E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2095_34534">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GoogleMeetIcon;
